import React, { useState, useEffect, useRef } from "react";
interface FAQItemProps {
  question: string;
  answer: string;
}

export default function FAQItem({ question, answer }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [verticalLineStyle, setVerticalLineStyle] = useState({
    transform: "rotate(0deg)",
    transition: "transform 0.4s ease",
    transformOrigin: "center"
  });
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    verticalLineTransform();
  }, [isOpen]);


  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isOpen]);

  const verticalLineTransform = () => {
    setVerticalLineStyle({
      transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
      transition: "transform 0.5s ease",
      transformOrigin: "center"
    });
  };

  return (
    <div
      onClick={() => setIsOpen(!isOpen)}
      className="faq-item-parent cursor-pointer my-3"
    >
      <div className="items-center w-full">
        <div className="grid grid-cols-6 w-full">
          <h4 className="h4 font-bold text-black col-span-5 my-3">
            {question}
          </h4>
          <div className="flex justify-end items-center col-span-1 mx-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.4em"
              height="1.4em"
              viewBox="0 0 30 30"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="mx-4 text-lg"
            >
              <line
                x1="0"
                y1="15"
                x2="30"
                y2="15"
                className="text-primary"
              ></line>
              <line
                x1="15"
                y1="0"
                x2="15"
                y2="30"
                className="text-primary text"
                style={verticalLineStyle}
              ></line>
            </svg>
          </div>

          <div
            className={`col-span-5 transition-all duration-300 ease-in-out overflow-hidden`}
            style={{ maxHeight: height }}
          >
            <div ref={contentRef}>
              <p
                className="body-reg"
                dangerouslySetInnerHTML={{ __html: answer }}
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
